import { translitToRus } from 'app/utils';
import { createSelector } from 'reselect';
const tokenState = (state) => state.token;
export const itemsTokenSelector = createSelector(tokenState, (token) => token.items);
export const searchValueTokenSelector = createSelector(tokenState, (token) => token.searchValue);
export const selectedItemTokenSelector = createSelector(tokenState, (token) => token.selectedItem);
export const transportGroupsTokenSelector = createSelector(tokenState, (token) => token.transportGroups);
export const transportGroupsTokenIdSelector = createSelector(tokenState, (token) => token.transportGroupsTokenId);
export const sortItemsTokenSelector = createSelector([itemsTokenSelector, searchValueTokenSelector], (items, searchValue) => {
    const compareFn = (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    if (searchValue.length) {
        return items.filter((item) => translitToRus(item.name).indexOf(translitToRus(searchValue)) !== -1).sort(compareFn);
    }
    return [...items].sort(compareFn);
});
